import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
import Wrp from "../../hoc/Wrp/Wrp";

class LongNumber extends Component {

  fieldOnChangeHandler(e){
    const {changeHandler} = this.props;
    let input_value = e.target.value.replace(/(\.\%)/,''); 
    if((input_value.search(/^[0]{1,}[\d]/)!==-1 || // takes care of leading zeroes
      input_value.search(/^(\d+)?[-]?([\d]{1,})?([\%])?$/)===-1) &&  //main pattern
      input_value!==''){
      // console.log('aaaaa')
      e.target.value  = (this.input_prev_value!==undefined)?this.input_prev_value:'';
      changeHandler(e.target.value);
    }else {  
        // console.log('ssssss')
        e.target.value = (input_value!==undefined)?input_value:'';
        this.input_prev_value = e.target.value;
        changeHandler(e.target.value);
    }
  } 

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);
    
    return (
      <Wrp>
        <input 
          type="text"
          {...attr}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={value}
          maxlength={this.props.max}
          max={this.props.max}
        />
      </Wrp>        
    );
  }
}

LongNumber.defaultProps = {
  isMandatory:false,
  className: 'form-control',
  max:18
}

export default LongNumber;